<template>
  <el-dialog
    title="Select your goals"
    :visible.sync="dialog_visible"
    width="75%"
    @open="onLoad">

    <div class="d-block">
      <!-- TODO: allow to update wizard goals -->

      <el-checkbox-group v-model="clone">
        <el-row :gutter="12">
          <el-col :span="8" v-for="(goal, key) in predefined_goals" :key="'goal-'+key">
              <el-card :body-style="{ padding: '0px' }">
                <div class="goal-img" :style="{ backgroundImage: imgurl(goal.img) }" :title="goal.desc"></div>
                <div style="padding: 14px;">
                  <div class="bottom clearfix">
                    <el-badge :value="goal.numOfLikes" class="item">
                      <el-checkbox :disabled="loading" :label="goal.id">{{goal.name}}</el-checkbox>
                    </el-badge>
                  </div>
                </div>
                <span class="goal-text"> {{goal.desc}} </span>
              </el-card>
          </el-col>
        </el-row>
      </el-checkbox-group>

      <!-- <pre>{{predefined_goals}}</pre> -->
      <!-- <pre>{{clone}}</pre> -->
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSaveSettings">OK</el-button>
    </span>

  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import oldRealTimeDb from "@/generic_api/firebase/rtdb";

export default {
  data() {
    return {
      dialog_visible: false,
      loading: false,
      predefined_goals: [],
      clone: {}
    }
  },
  computed: {
    ...mapGetters("user", [
      "userData"
    ]),
  },
  methods: {
    showModal() {
      this.dialog_visible = true;
    },
    onLoad() {

      if ( this.userData  && 'selectedGoals' in this.userData) {
        this.clone = [];
        this.loading = true

        oldRealTimeDb
          .ref('predefined_goals')
          .limitToFirst(100)
          .once("value", (snapshot) => {
            let val = snapshot.val();
            this.predefined_goals = [];
            Object.keys(val).map(key => {
              if ( this.userData.selectedGoals.includes( key ) ) {
                this.clone.push(key)
              }
              this.predefined_goals.push({ id: key, ...val[key] });
            });

            this.loading = false;
          });
      }
    },
    onSaveSettings() {
      this.$api.user_update_settings_by_prefix({
        data: this.clone,
        prefix: 'selectedGoals'
      }).then(() => {
        console.log( "Successfully updated user selectedGoals" );
      this.dialog_visible = false;

        this.$emit('save');
      });
    },
    imgurl(img) {
      return `url('${img}')`;
    }
  }
};
</script>

<style>
.goal-text {
  display: block;
  margin: 8px;
  color: black;
  padding: 0;
  font-size: 10pt;
}
.goal-img {
  width: 248px;
  height: 154px;
  background-position: 50% 25%;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
